export const countries = [
{
	"name": 'USA',
	"abbreviation": 'US',
},
{
	"name": 'Canada',
	"abbreviation": 'ca',
}];


// WEBPACK FOOTER //
// ./src/utils/constants/countries.js